/* tslint:disable */
import _ from 'lodash';
import { createDecorator } from 'vue-class-component';
import { mapGetters, mapActions } from 'vuex';

interface IVuexMapping {
  getter: string,
  setter: string
}

export const Computed = function(params: IVuexMapping) {
  return createDecorator(function(o, k: string) {
    if (typeof o.computed === 'undefined') {
      o.computed = {};
    }
    let _g: any, _a: any;
    const getterMapObject = (_g = {}, _g[k] = params.getter, _g);
    const actionMapObject = (_a = {}, _a[k] = params.setter, _a);
    const mappedGetter = mapGetters(getterMapObject)[k];
    const mappedSetter = mapActions(actionMapObject)[k];
    o.computed[k] = {
      get() {
        return mappedGetter.apply(this);
      },
      set(v: any) {
        mappedSetter.apply(this, [v])
      }
    }
  });
}

export const Debounce = function(delay: number) {
  return createDecorator(function(o, k: string, i: any) {
    if (typeof o.methods === 'undefined' || typeof o.methods[k] === 'undefined') {
      return;
    }
    const original = o.methods[k];
    const proxy = _.debounce(original, delay, {
      trailing: true
    });
    o.methods[k] = proxy;
  });
}